<template>
  <div v-if="!!item" class="localView" :data-placeid="item.placeId" :class="{mapPadding: isMap}">
    <LocalMap :info="mapInfo" v-if="isMap"/>
    <!-- <div class="map">
      <iframe :src="`https://www.google.com/maps?q=${item.name}&output=embed`" width="100%" height="100%"></iframe>
    </div> -->
    <div class="localDetail">
      <button type="button" class="notranslate btnBack" @click.stop="goBack">&#8592;</button>
      <!-- name -->
      <p class="name"><img :src="item.icon" />{{item.name}}</p>
      <!-- //name -->
      <!-- distance -->
      <p class="long notranslate">
        <span :style="{'float': 'left'}">
          <span class="distance">{{distance}}</span>
          <span class="walking">{{onfoot}}</span>
        </span>
        <button @click="isMap = !isMap" class="openMap">
          <img src="@/assets/img/ico_location.png" :style="{'width': '20px'}"><br>
          <span>Map</span>
        </button>
      </p><br>
      <!-- //distance -->
      <!-- rating -->
      <div class="rating notranslate">
        <span class="rate">{{`${!!item.rating ? item.rating : 0} / 5`}}</span>
        <div class="ratingStar">
          <span class="star"></span>
          <span class="bar" :style="rating(item.rating)"></span>
        </div>
        <span v-if="!!item.user_ratings_total" class="ratedUser">{{`(${item.user_ratings_total})`}}</span>
      </div>
      <!-- //rating -->
      <!-- photos -->
      <div v-if="!!item.sitePhotos && item.sitePhotos.length" class="carousel">
        <Carousel
          :loop="true"
          :perPage="1"
          :mouseDrag="true"
          :paginationPadding="4"
          :paginationActiveColor="'rgba(0,0,0,0.4)'"
          :paginationColor="'rgba(0,0,0,0.2)'">
          <Slide v-for="(img, index) in item.sitePhotos" :key="index">
            <img :src="`https://google-map-photos.s3.ap-northeast-2.amazonaws.com/${img}`" alt="" />
          </Slide>
        </Carousel>
      </div>
      <!-- //photos -->
      <!-- review -->
      <div v-if="!!item.reviews && item.reviews.length" class="review mt10">
        <div
          v-for="(review, index) in item.reviews"
          :key="index" class="item mt15">
          <div class="reviewer notranslate">
            <div class="thumb"><img :src="review.profile_photo_url"></div>
            <span class="user">{{review.author_name}}</span>
            <div class="star">
              <span v-for="star in 5" :key="star" :class="{on: star < review.rating + 1}">&#9733;</span>
              <span class="time">{{review.relative_time_description}}</span>
            </div>
          </div>
          <div class="context mt5"
            :class="{more: review.isOpen}"
            @click.stop="toggleReview($event)">
            {{review.text}}
          </div>
        </div>
      </div>
      <!-- //review -->
      <!-- place info -->
      <div class="place">
        <!-- tel -->
        <p v-if="!!item.formatted_phone_number" class="tel notranslate"><a :href="`tel:${item.international_phone_number}`">{{item.formatted_phone_number}}</a></p>
        <!-- address -->
        <p v-if="item.formatted_address" class="address mt10 notranslate">{{item.formatted_address}}</p>
      </div>
      <!-- //place info -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LocalMap from '@/components/LocalInfo/LocalMap.vue'
import regExp from '@/common/regExp'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'LocalView',
  data() {
    return {
      isMap:false
    }
  },
  props: [
    'placeId',
    'lang',
    'locale'
  ],
  components: {
    LocalMap,
    Carousel,
    Slide
  },
  computed: {
    ...mapGetters({
      getLocalInfo: 'localinfo/getLocalInfo'
    }),
    item () {
      return this.getLocalInfo(this.placeId)
    },
    mapInfo () {
      const info = this.item
      return {
        placeId: info.placeId,
        address: info.formatted_address,
        location: info.geometry.location,
        from: {
          label: 'HOTEL',
          lat: parseFloat(info.geometry.from.lat),
          lng: parseFloat(info.geometry.from.lng)
        },
        viewportNorth: info.geometry.viewport.northeast,
        viewportSouth: info.geometry.viewport.southeast,
        distance: info.distance
      }
    },
    distance () {
      const distance = this.item.distance
      const d = distance >= 1000 ? (distance / 1000).toFixed(1) : distance
      const unit = distance >= 1000 ? 'km' : 'm'
      return `${this.locale.localinfo_fromhotel} ${regExp.comma(d)}${unit}`
    },
    onfoot () {
      const secPerDistance = Math.floor(this.item.distance * 0.9) // sec per distance :: 1분에 66.6m -> 1m당 0.9초
      const LOCALE = this.locale
      function minSec (seconds) {
        const hour = parseInt(seconds / 3600)
        const min = parseInt((seconds % 3600) / 60)
        const sec = seconds % 60
        let message = `${LOCALE.localinfo_onfoot} `
        if (seconds <= 60) {
          message += LOCALE.within1min
        } else {
          if (hour >= 1) {
            message += `${LOCALE.time_about} ${hour}${LOCALE.hour}`
          }
          if (min >= 1) {
            message += `${LOCALE.time_about} ${min}${LOCALE.minute}`
          }
          // if (sec >= 1) {
          //   message = message += ` ${sec}${LOCALE.seconds}`
          // }
        }
        return message
      }
      return minSec(secPerDistance)
    }
  },
  mounted () {
    setTimeout(() => {
      window.scrollTo(0, 0)
    })
  },
  methods: {
    toggleReview (e) {
      const toggle = e.currentTarget.className.includes('more') ? 'remove' : 'add'
      e.currentTarget.classList[toggle]('more')
    },
    rating (rating) {
      const rate = !!rating ? rating : 0
      const percent = Math.floor(rate / 5 * 100)
      return {
        width: `${percent}%`
      }
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.openMap{
  float: right;
  width: 24px;
  font-size: 11px;
  color: black;
}
.localView {
  position: relative;
  background-color: $color-white;
}
.mapPadding{
  padding-top: 400px;
}
.btnBack {
  font-family: arial;
  font-weight: bold;
  font-size: 1.5em;
}

@media (orientation: landscape) {
  .mapPadding{
    padding-top: 0px;
  }
}
</style>
